export const SET_CATEGORY_INFO = 'SET_CATEGORY_INFO';
